import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trophy, HelpCircle, Users } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function QuizzesPage() {
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/public/quizzes`)
      .then(r => r.json())
      .then(d => setQuizzes(Array.isArray(d) ? d : (d.quizzes || d.items || [])))
      .catch(() => setQuizzes([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container mx-auto max-w-6xl px-4 py-8" data-testid="quizzes-page">
      <header className="mb-8 border-l-4 border-red-600 pl-4">
        <h1 className="text-4xl sm:text-5xl font-black text-gray-900 dark:text-gray-100">Kvizovi</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">Provjerite svoje znanje o Hrvatskoj, Međimurju i aktualnim vijestima.</p>
      </header>
      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-52 rounded-xl bg-gray-100 dark:bg-[#0f172a] animate-pulse" />
          ))}
        </div>
      ) : quizzes.length === 0 ? (
        <div className="text-center py-16 text-gray-500 dark:text-gray-400" data-testid="quizzes-empty">
          Trenutačno nema objavljenih kvizova.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {quizzes.map(q => (
            <Link
              key={q.id}
              to={`/kviz/${q.slug}`}
              data-testid={`quiz-card-${q.slug}`}
              className="group block rounded-xl overflow-hidden border border-gray-200 dark:border-gray-800 bg-white dark:bg-[#0f172a] hover:border-red-500/60 hover:shadow-lg transition"
            >
              {q.cover_image_url ? (
                <div className="aspect-[16/10] overflow-hidden bg-gray-100 dark:bg-gray-900">
                  <img src={q.cover_image_url} alt="" className="w-full h-full object-cover group-hover:scale-105 transition" />
                </div>
              ) : (
                <div className="aspect-[16/10] bg-gradient-to-br from-red-500/10 to-rose-500/20 flex items-center justify-center">
                  <HelpCircle size={40} className="text-red-500/60" />
                </div>
              )}
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300">
                  {q.category || 'opće znanje'} · {q.difficulty || 'medium'}
                </span>
                <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mt-2 line-clamp-2">{q.title}</h3>
                {q.description && (
                  <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 line-clamp-2">{q.description}</p>
                )}
                <div className="flex items-center gap-4 mt-3 text-xs text-gray-400">
                  <span className="inline-flex items-center gap-1"><HelpCircle size={12} /> {(q.questions || []).length} pitanja</span>
                  <span className="inline-flex items-center gap-1"><Users size={12} /> {q.plays || 0}</span>
                  <span className="inline-flex items-center gap-1"><Trophy size={12} /> {q.avg_score || 0}%</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
